import { Store } from "@/custom-types/StoreLocator";
import { useSelector } from "@/redux/hooks";
import { getCountryCode } from "@/redux/selectors/location";

const useDispensaryRouteGen = (store: Store) => {
  const countryCode = useSelector(getCountryCode);

  const dealLink = (dealTitle = store.mostRecentActiveDeal?.title) => {
    const dispensaryRoute =
      countryCode === "CA" ? "cannabis-store" : "dispensary-info";
    return dealTitle
      ? `/${dispensaryRoute}/${store.slug}/menu?deal_title[]=${encodeURIComponent(dealTitle)}`
      : undefined;
  };

  return {
    dealLink,
  };
};

export default useDispensaryRouteGen;
